import { render, staticRenderFns } from "./TermoAceite.vue?vue&type=template&id=450a2531&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/spa/termo-aceite/TermoAceite.vue
// module id = 1498
// module chunks = 28